import { type FC } from 'react'

import { ExperimentStickyBuyBoxCta } from './ExperimentStickyBuyBoxCta'

export const ExperimentStickyBuyBoxV3Mobile: FC<{
  disableCta: boolean
}> = ({ disableCta }) => (
  <div className="fixed inset-x-0 bottom-0 z-10 flex items-center justify-between bg-light-primary-low p-6 shadow-[0_6px_12px_#00000033] tablet:hidden">
    <ExperimentStickyBuyBoxCta disableCta={disableCta} />
  </div>
)
